import React from 'react';

import { WillGenerator } from '@components/WillGenerator';
import { StyledCard, StyledCardContent, StyledTitle } from './WillCreatorContainer.styles';

export default function WillCreatorContainer() {
    return (
        <StyledCard>
            <StyledCardContent>
                <StyledTitle>
                    Create Your Will
                </StyledTitle>
                <WillGenerator />
            </StyledCardContent>
        </StyledCard>
    );
}